<template>
    <div class="page_header">
        <div class="header_left">
            <img src="../assets/images/logo.png" alt="">
            <p>企业管理后台</p>
        </div>

        <div class="header_right">
            <img :src="info.head_pic" alt="" class="avatars">

            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    {{info.realname}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="viewCompanyInfo" v-if="info.is_certified	== 2 && info.type !== 3 ">公司信息</el-dropdown-item>
                    <el-dropdown-item command="loginOut">退出</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageHeader",
    props: ["info"],
    data(){
        return{

        }
    },
    methods: {
        // 账户下拉菜单选择事件
        handleCommand(command){ 
            // console.log(command);
            if(command == "loginOut"){
                localStorage.clear();
                sessionStorage.clear();

                this.$router.push("/login")
            } else if(command == "viewCompanyInfo") {
                this.$router.push("/companyinfo")
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .page_header
        width 100%
        height 64px
        background #202020
        color white
        font-size 24px
        display flex
        align-items center
        justify-content space-between
        white-space nowrap
        .header_left
            width auto
            display flex
            align-items center
            margin-left 2%
            font-size $normalSize
            img 
                width 55px
                height 16px
                margin-right 10px
            p
                border-left 1px solid white
                padding 0 0 0 10px
        .header_right
            width auto
            display flex
            align-items center
            margin-right 2%
            .avatars
                width 24px
                height 24px
                border-radius 50%
                background #D8D8D8
            .el-dropdown-link
                font-size 14px 
                margin 0 0 0 12px
                color white
</style>




// WEBPACK FOOTER //
// src/components/PageHeader.vue